module.exports = __webpack_public_path__ + "img/6.ded80b65.jpg";